module.exports = __webpack_public_path__ + "img/T932.6e639066.jpg";